/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RollupResult
 */
export interface RollupResult {
    /**
     * 
     * @type {string}
     * @memberof RollupResult
     */
    parentInitiativeId?: string;
    /**
     * 
     * @type {Date}
     * @memberof RollupResult
     */
    computedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof RollupResult
     */
    designedScore?: number;
    /**
     * 
     * @type {number}
     * @memberof RollupResult
     */
    operationalScore?: number;
    /**
     * 
     * @type {number}
     * @memberof RollupResult
     */
    validatedScore?: number;
    /**
     * 
     * @type {number}
     * @memberof RollupResult
     */
    childrenTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof RollupResult
     */
    childrenContributingDesigned?: number;
    /**
     * 
     * @type {number}
     * @memberof RollupResult
     */
    childrenContributingOperational?: number;
    /**
     * 
     * @type {number}
     * @memberof RollupResult
     */
    childrenContributingValidated?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RollupResult
     */
    partialRollupDesigned?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RollupResult
     */
    partialRollupOperational?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RollupResult
     */
    partialRollupValidated?: boolean;
}

/**
 * Check if a given object implements the RollupResult interface.
 */
export function instanceOfRollupResult(value: object): value is RollupResult {
    return true;
}

export function RollupResultFromJSON(json: any): RollupResult {
    return RollupResultFromJSONTyped(json, false);
}

export function RollupResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): RollupResult {
    if (json == null) {
        return json;
    }
    return {
        
        'parentInitiativeId': json['parentInitiativeId'] == null ? undefined : json['parentInitiativeId'],
        'computedAt': json['computedAt'] == null ? undefined : (new Date(json['computedAt'])),
        'designedScore': json['designedScore'] == null ? undefined : json['designedScore'],
        'operationalScore': json['operationalScore'] == null ? undefined : json['operationalScore'],
        'validatedScore': json['validatedScore'] == null ? undefined : json['validatedScore'],
        'childrenTotal': json['childrenTotal'] == null ? undefined : json['childrenTotal'],
        'childrenContributingDesigned': json['childrenContributingDesigned'] == null ? undefined : json['childrenContributingDesigned'],
        'childrenContributingOperational': json['childrenContributingOperational'] == null ? undefined : json['childrenContributingOperational'],
        'childrenContributingValidated': json['childrenContributingValidated'] == null ? undefined : json['childrenContributingValidated'],
        'partialRollupDesigned': json['partialRollupDesigned'] == null ? undefined : json['partialRollupDesigned'],
        'partialRollupOperational': json['partialRollupOperational'] == null ? undefined : json['partialRollupOperational'],
        'partialRollupValidated': json['partialRollupValidated'] == null ? undefined : json['partialRollupValidated'],
    };
}

export function RollupResultToJSON(json: any): RollupResult {
    return RollupResultToJSONTyped(json, false);
}

export function RollupResultToJSONTyped(value?: RollupResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parentInitiativeId': value['parentInitiativeId'],
        'computedAt': value['computedAt'] == null ? undefined : ((value['computedAt']).toISOString()),
        'designedScore': value['designedScore'],
        'operationalScore': value['operationalScore'],
        'validatedScore': value['validatedScore'],
        'childrenTotal': value['childrenTotal'],
        'childrenContributingDesigned': value['childrenContributingDesigned'],
        'childrenContributingOperational': value['childrenContributingOperational'],
        'childrenContributingValidated': value['childrenContributingValidated'],
        'partialRollupDesigned': value['partialRollupDesigned'],
        'partialRollupOperational': value['partialRollupOperational'],
        'partialRollupValidated': value['partialRollupValidated'],
    };
}

